import React from "react";
import ReactDOM from "react-dom";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { muiTheme } from "./theme/muiTheme";

// Touch devices: `:active` pseudo-class can stick after touchend — blur the focused element to clear it.
// Inputs and textareas are excluded: they manage their own focus lifecycle and should never be blurred by a scroll or tap elsewhere.
if (!(window as any).__touchBlurRegistered) {
  (window as any).__touchBlurRegistered = true;
  document.addEventListener(
    "touchend",
    (e) => {
      const active = document.activeElement;
      if (
        active instanceof HTMLElement &&
        active.tagName !== "INPUT" &&
        active.tagName !== "TEXTAREA" &&
        !active.contains(e.target as Node)
      ) {
        active.blur();
      }
    },
    { passive: true },
  );
}

export function renderPage(element: React.ReactElement, selector: string) {
  const rootEl = document.querySelector(selector);
  if (!rootEl) return;

  ReactDOM.render(
    <ThemeProvider theme={muiTheme}>
      <CssBaseline />
      {element}
    </ThemeProvider>,
    rootEl,
  );
}
